import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'wlm-repeat-type',
    templateUrl: './repeat-type.component.html',
    styleUrl: './repeat-type.component.scss',
    standalone: false
})
export class RepeatTypeComponent extends FieldType<FieldTypeConfig> {}
